<script setup lang="ts">

import type { IMyGarageViewModel } from "../..";
import { useAppConfiguration } from "@domain/AppConfiguration";

import ProfileAlerts from "./ProfileAlerts.vue";
import ProfileVehicle from "./ProfileVehicle.vue";
import ProfileActions from "./ProfileActions.vue";
import ProfileNavigationBar from "./ProfileNavigationBar.vue";
import ProfileSetHomeDealership from "./ProfileSetHomeDealership.vue";
import { useUserSettings } from "@services/UserSettings";

const model = defineModel<IMyGarageViewModel>( { required: true } );  
const app = useAppConfiguration();
const settings = useUserSettings();

</script>

<template>

    <div class="w-full tracking-wider bg-gray-900">

        <div class="flex flex-col w-full">
        
            <div class="text-lg lg:text-xl w-full
                        flex flex-col justify-between ">
               
                <!-- ALERTS -->
                <div class="bg-gray-950/20">
                    <ProfileAlerts v-model="model"/>
                </div>

                
                <div class="mt-8 2xl:mt-10
                    bg-gradient-to-b from-gray-850 to-gray-850 via-50%
                    rounded-tr-lg 2xl:rounded-tr-xl pb-2">
                                       
                    <ProfileVehicle v-model="model" />
                    <ProfileActions v-model="model" />
                    <ProfileNavigationBar v-model="model" />
                    <ProfileSetHomeDealership v-if="app.isGeneric && settings.expandProfileActions" />

                </div>

             </div>

        </div>
    
    </div>

</template>